export const lowerCaseFirstLetter = (s) => {
    if (typeof s !== 'string')
        return '';
    return s.charAt(0).toLowerCase() + s.slice(1);
};
export const camelize = (str) => {
    if (!str || !str.includes('-')) {
        return str;
    }
    const arr = str.split('-');
    const capital = arr.map((item) => item.charAt(0).toUpperCase() + item.slice(1).toLowerCase());
    return lowerCaseFirstLetter(capital.join(''));
};
export const toKebabCase = (str) => str
    .replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, '$1-$2')
    .replace(/ /, '-')
    .replace(/ /, '-')
    .toLowerCase();
export const normalizeDesignTokenName = (key) => toKebabCase(lowerCaseFirstLetter(key)).replace('go-to-', '');
export const hexToRgb = (hex) => {
    // Remove the hash (if included)
    hex = hex.replace('#', '');
    let rgba;
    if (hex.length === 3) {
        rgba = {
            r: parseInt(hex.charAt(0).repeat(2), 16),
            g: parseInt(hex.charAt(1).repeat(2), 16),
            b: parseInt(hex.charAt(2).repeat(2), 16),
            a: 1,
        };
    }
    else if (hex.length === 4) {
        rgba = {
            r: parseInt(hex.charAt(0).repeat(2), 16),
            g: parseInt(hex.charAt(1).repeat(2), 16),
            b: parseInt(hex.charAt(2).repeat(2), 16),
            a: parseFloat((parseInt(hex.charAt(3).repeat(2), 16) / 255).toFixed(2)),
        };
    }
    else if (hex.length === 6) {
        rgba = {
            r: parseInt(hex.slice(0, 2), 16),
            g: parseInt(hex.slice(2, 4), 16),
            b: parseInt(hex.slice(4, 6), 16),
            a: 1,
        };
    }
    else if (hex.length === 8) {
        rgba = {
            r: parseInt(hex.slice(0, 2), 16),
            g: parseInt(hex.slice(2, 4), 16),
            b: parseInt(hex.slice(4, 6), 16),
            a: parseFloat((parseInt(hex.slice(6, 8), 16) / 255).toFixed(2)),
        };
    }
    else {
        console.error('Invalid HEX color');
        return null;
    }
    // Check if any of the parsed values are NaN and return null if so
    if (isNaN(rgba.r) || isNaN(rgba.g) || isNaN(rgba.b) || isNaN(rgba.a)) {
        console.error('Invalid HEX color');
        return null;
    }
    return rgba;
};
export const applyColorAlpha = (color, alpha) => {
    const { r, g, b } = hexToRgb(color);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};
const normalizeValue = (value, key) => {
    // Wrap the box-shadow with parentheses
    if (key.startsWith('elevation') || key.startsWith('transition')) {
        value = `(${value})`;
    }
    return value;
};
/*
  Removes the duplicate `goto`, and coverts the key of the object to a kebab-case name
*/
export const normalizeKeys = (obj) => {
    const returnValue = {};
    Object.keys(obj).forEach((key) => {
        const normalizedKey = normalizeDesignTokenName(key);
        returnValue[normalizedKey] = normalizeValue(obj[key], normalizedKey);
    });
    return returnValue;
};
